export const NUMBER_OF_LEADS = 'numberOfLeads';
